
<template>
  <div id="collection-pagination-controls" class="collection-pagination-controls body-md">
    <div class="collection-load-more" v-if="showLoadMore">
      <div v-if="!loadingStatus" class="collection-load-more__progress">
        <span class="collection-load-more__progress-total" :style="progressPercentStyle"></span>
      </div>
      <p
        v-if="!loadingStatus"
        class="collection-load-more__showing body-md"
      >Showing {{ numShowing }} of {{ currentTotal }} Products</p>
      <v-button
        v-if="!loadingStatus"
        class="collection-load-more__btn"
        type="button"
        :primary="true"
        @click="loadMore"
      >Load More &plus;</v-button>
      <div class="spinner" v-if="loadingStatus">
        <div class="double-bounce1"></div>
        <div class="double-bounce2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/scripts/components/basic/Icon.vue';
import VButton from '@/scripts/components/buttons/VButton.vue';

export default {
  name: 'CollectionPaginationControlsB',
  components: { Icon, VButton },
  props: {
    initPages: {
      type: Number,
      required: true,
    },
    bottomPagination: {
      type: Boolean,
      default: false,
    },
    paginationAmount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pageNavActive: false,
    };
  },
  computed: {
    ...mapState({
      currentPage: (state) => state.collections.currentPage,
      currentTotal: (state) => state.collections.currentTotal,
      loadingStatus: (state) => state.collections.loadingStatus,
    }),
    numShowing() {
      return Math.min(
        this.paginationAmount * this.currentPage,
        this.currentTotal
      );
    },
    progressPercentStyle() {
      return { width: `${(this.numShowing / this.currentTotal) * 100}%` };
    },
    pages() {
      if (this.currentTotal < this.paginationAmount) {
        return 1;
      } else {
        return this.initPages;
      }
    },
    showLoadMore() {
      return this.pages > 1 && this.currentPage !== this.pages;
    },
  },
  methods: {
    loadMore() {
      if (this.currentPage !== this.pages) {
        this.$store.dispatch('collections/fetchMoreProducts', this.currentPage);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.collection-pagination-controls {
  display: flex;
  align-items: center;
  user-select: none;

  .collection-load-more {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &__progress {
      position: relative;
      width: 312px;
      height: 3px;
      background-color: $color-lightest-grey;
      margin-bottom: 20px;
      @include mobile-only {
        width: 300px;
      }
    }

    &__progress-total {
      position: absolute;
      background-color: $color-black;
      display: block;
      left: 0;
      top: 0;
      height: 3px;
      width: 0;
    }

    &__showing {
      margin-bottom: 24px;
    }
  }

  // spinner
  .spinner {
    width: 40px;
    height: 40px;

    position: relative;
    margin: 0 auto;
  }

  .double-bounce1,
  .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: $color-light-grey;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;

    -webkit-animation: sk-bounce 2s infinite ease-in-out;
    animation: sk-bounce 2s infinite ease-in-out;
  }

  .double-bounce2 {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  @-webkit-keyframes sk-bounce {
    0%,
    100% {
      -webkit-transform: scale(0);
    }
    50% {
      -webkit-transform: scale(1);
    }
  }

  @keyframes sk-bounce {
    0%,
    100% {
      transform: scale(0);
      -webkit-transform: scale(0);
    }
    50% {
      transform: scale(1);
      -webkit-transform: scale(1);
    }
  }
}
</style>
